import React, { useEffect, useState } from "react";

import {
  deleteRoom,
  getRoomsForHostel,
} from "../../../services/OrganisationServices/hostelRoomServices";
import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import { useParams } from "react-router-dom";
import { getHostelGuestList } from "../../../services/OrganisationServices/hostelManagmentService";
import { useGlobalState } from "../../../services/hostelConst.js";
const GuestTable = () => {
  var { id } = useParams();

  return (
    <div>
      <MasterTable
        getTableData={getHostelGuestList}
        tab1={"Hostel"}
        tab2={"User Guest"}
        hostelId={id}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
        deleteRow={deleteRoom}
      />
    </div>
  );
};

export default GuestTable;
